/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tokens_CreateInputs */

const cs_import_tokens_create = /** @type {(inputs: Import_Tokens_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit token`)
};

const en_import_tokens_create = /** @type {(inputs: Import_Tokens_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create token`)
};

/**
* | output |
* | --- |
* | "Create token" |
*
* @param {Import_Tokens_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tokens_create = /** @type {((inputs?: Import_Tokens_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tokens_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tokens_create(inputs)
	return cs_import_tokens_create(inputs)
});